import { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { Box, MenuItem, Divider } from '@mui/material';
import { advancedSearchTickets } from '../../../api/tickets';
import Markdown from '../../../reusable-components/markdown';
import { highlightText } from '../../../reusable-components/highlight-element/highlight-element';
import QuickSearchDropdown from './QuickSearchDropdown';

TicketSearchQuickDropdown.propTypes = {
  searchValue: PropTypes.string, 
  quickAdvancedFilter: PropTypes.bool,
  setQuickAdvancedFilter: PropTypes.func,
  searchInputRef: PropTypes.object,
}

export default function TicketSearchQuickDropdown({ searchValue, quickAdvancedFilter, setQuickAdvancedFilter, searchInputRef }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState(null);

  const handleSearchCall = () => {
    setLoading(true);
    advancedSearchTickets({ searchValue, page: 1, messageSearch: true, baseTicketSearch: true, userSearch: true, quickSearch: true, pageSize: 5 })
      .then((res) => setSearchResults(res.data ?? {}))
      .catch(() => enqueueSnackbar("Failed to load messages", { variant: "error" }))
      .finally(() => setLoading(false));
  };

  const goToAdvancedSearch = () => navigate(`/dashboard/advanced-search?messageSearch=true&baseTicketSearch=true&userSearch=true&searchValue=${searchValue}&base=tickets&page=1`);
  const goToTicket = (id, parentTicketId) => navigate(parentTicketId > 0 ? `/dashboard/tickets/${parentTicketId}?subticket=${id}` :`/dashboard/tickets/${id}`);

  const SearchResultItems = searchResults?.searchResults?.map((res, index) => 
    <MenuItem key={index} onClick={() => goToTicket(res.id, res.subticket?.parentTicketId > 0 ? res.subticket.parentTicketId : 0)} sx={{ whiteSpace: 'break-spaces' }}>
      <Box>
        <Box display="flex" justifyContent="space-between">
          <Markdown sx={{ "& .MuiTypography-root": { fontWeight: "700" } }} children={`Ticket# ${highlightText(res.subticket?.subTicketName ?? res.id, searchValue)} | Facility: ${highlightText(res.facility, searchValue)}`} />
          {res.complete && <Box sx={{ ml: 1 }} color="text.secondary">Complete</Box>}
        </Box>
        <Markdown children={`**Subject**: ${highlightText(res.subject, searchValue)}`} />
        {res.messages && res.messages.length > 0 && <Box>
          <Divider color="#c3c0c0" sx={{ my: .3 }} />
           <Markdown sx={{ "& .MuiTypography-root": { fontSize: "small !important" } }} children={highlightText(res.messages[0].message, searchValue)} />
        </Box>}
        <Divider color="black" sx={{ mt: .5 }} />
      </Box>
    </MenuItem>)

  return <QuickSearchDropdown
    loading={loading}
    handleSearchCall={handleSearchCall}
    goToAdvancedSearch={goToAdvancedSearch}
    searchResultItems={SearchResultItems}
    quickAdvancedFilter={quickAdvancedFilter}
    setQuickAdvancedFilter={setQuickAdvancedFilter}
    searchValue={searchValue}
    setSearchResults={setSearchResults}
    searchResults={searchResults}
    searchInputRef={searchInputRef}
  />;
}
